import IndexReferenceType from './IndexReferenceType';

export default class ProvisionClauseType {
    id: number;
    name: string;
    description: string;
    omitObligation?: boolean;

    // not mapped
    isDefault?: boolean;
    contractTypeId?: number;
    provisionUnits: IndexReferenceType[];
    provisionValues: IndexReferenceType[];
}


// WEBPACK FOOTER //
// ./src/models/ProvisionClauseType.ts